import { puppetInterviewFirebaseConfig } from './puppet-interview-config';
import { sabolFirebaseConfig } from './sabol-config';

import { APP_ENV, API_BASE_URL } from './consts';
import { crestFirebaseConfig } from './crest-config';

const getFirestoreConfig = () => {
    switch (APP_ENV) {
        case 'sabol':
            return sabolFirebaseConfig;
        case 'puppet-interview':
            return puppetInterviewFirebaseConfig;
        case 'crest':
            return crestFirebaseConfig;

        default:
            return puppetInterviewFirebaseConfig;
    }
};

export const firebaseConfig = getFirestoreConfig();

// To use puppet-interview settings during local dev run: `APP_ENV='puppet-interview' yarn start `
interface AppConfig {
    API_BASE_URL: string;
    firebaseConfig: typeof sabolFirebaseConfig;
}

/**
 * Assign specific configuration settings based on APP_ENV
 * environment variable passed in at build time
 */

let config;
switch (APP_ENV) {
    case 'sabol':
        config = {
            API_BASE_URL,
            firebaseConfig,
        };
        break;
    case 'puppet-interview':
        config = {
            API_BASE_URL,
            firebaseConfig,
        };
        break;
    case 'crest':
        config = {
            API_BASE_URL,
            firebaseConfig,
        };
        break;
    default:
        throw new Error(`Unhandled APP_ENV: ${APP_ENV}`);
}

export default config as AppConfig;
